import {Typography} from '@customink/pigment-react';
import {
  signaler,
  SignalerFeatureFlagName
} from '~/adapters/signaler/signalerFeatureFlags';
import {useSignalerContext} from '~/adapters/signaler/SignalerContext';

interface CurrentFlagValueProps {
  featureName: SignalerFeatureFlagName;
}

export function CurrentFlagValue({featureName}: CurrentFlagValueProps) {
  const {version} = useSignalerContext();
  const flagValue = signaler.featureFlag(featureName);

  return (
    <Typography key={version} variant="uiTextSmall">
      {flagValue}
    </Typography>
  );
}
